import { useState } from 'react';
import { supabase } from '../../lib/supabase';

interface ForecastParametersTabProps {
  forecastData: any;
}

export default function ForecastParametersTab({ forecastData }: ForecastParametersTabProps) {
  const { scenario, loadAll } = forecastData;
  const [name, setName] = useState(scenario.name);
  const [startDate, setStartDate] = useState(scenario.start_date);
  const [yearsCount, setYearsCount] = useState(scenario.years_count);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    try {
      const { error } = await supabase
        .from('forecast_scenarios')
        .update({
          name: name.trim(),
          start_date: startDate,
          years_count: yearsCount
        })
        .eq('id', scenario.id);

      if (error) throw error;

      await loadAll();
      alert('Paramètres sauvegardés avec succès');
    } catch (error) {
      console.error('Error saving parameters:', error);
      alert('Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-2xl">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Paramètres du scénario</h2>

      <div className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Nom du scénario *
          </label>
          <input
            type="text"
            value={name}
            onChange={e => setName(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Date de début du premier exercice *
          </label>
          <input
            type="date"
            value={startDate}
            onChange={e => setStartDate(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <p className="text-xs text-gray-500 mt-1">
            L'exercice fiscal débutera chaque année à cette date
          </p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Nombre d'années *
          </label>
          <select
            value={yearsCount}
            onChange={e => setYearsCount(Number(e.target.value))}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            {[3, 4, 5, 6, 7, 8, 9, 10].map(n => (
              <option key={n} value={n}>
                {n} ans
              </option>
            ))}
          </select>
        </div>

        <div>
          <button
            onClick={handleSave}
            disabled={saving || !name.trim()}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {saving ? 'Sauvegarde...' : 'Sauvegarder'}
          </button>
        </div>
      </div>
    </div>
  );
}
